const header = document.getElementById('header');

if (header) {
    const header_height = header.offsetHeight;
    let scrollpos = window.scrollY;

    const add_class_on_scroll = () => header.classList.add('blend-difference');
    const remove_class_on_scroll = () => header.classList.remove('blend-difference');

    window.addEventListener('scroll', function () {
        scrollpos = window.scrollY;

        if (scrollpos >= header_height) {
            add_class_on_scroll();
        } else {
            remove_class_on_scroll();
        }
    });
}
